<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--기타비용명세-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC002143') }}</span>
				</div>
				<div v-if="!pwaApcnPopUp.readOnlyAuth" class="ml-auto d-flex">
					<sf-button size="sm" line icon="square-plus" :onClick="addRow">{{ getMessage_('MWCC000007') }}</sf-button>
					<sf-button size="sm" color="error" line icon="trash" :onClick="deleteRows">{{ getMessage_('MWCC000328') }}</sf-button>
				</div>
			</div>

			<sf-data-table
				ref="otherFeeTable"
				:paging="false"
				:columns="cols"
				:rows="localRows"
				:excel="false"
				:stripe="false"
				selection
				fit
				height="300px"
			>
				<template v-slot:customRows="slotProps">
					<template v-if="slotProps.column.property === 'no'">
						{{ slotProps.row.no }}
					</template>

					<template v-if="slotProps.column.property === 'feeTypeCd'">
						<el-select
							v-if="!pwaApcnPopUp.readOnlyAuth"
							v-model="slotProps.row.feeTypeCd"
							@change="onCellChange"
							style="width: 100%"
						>
							<el-option :key="index"
										v-for="(result, index) in feeTypeOptions"
										:label="result.commCdName"
										:value="result.commCd" />
						</el-select>
						<span v-else>{{ getFeeTypeLabel(slotProps.row.feeTypeCd) }}</span>
					</template>

					<template v-if="slotProps.column.property === 'remark'">
						<el-input v-model="slotProps.row.remark" :readonly="pwaApcnPopUp.readOnlyAuth" maxlength="200" />
					</template>

					<template v-if="slotProps.column.property === 'unitPrice'">
						<el-input
							:value="slotProps.row.unitPrice"
							:readonly="pwaApcnPopUp.readOnlyAuth"
							@input="val => onUnitPriceInput(val, slotProps.row)"
						/>
					</template>

					<template v-if="slotProps.column.property === 'feeQty'">
						<el-input
							:value="slotProps.row.feeQty"
							:readonly="pwaApcnPopUp.readOnlyAuth"
							@input="val => onQtyInput(val, slotProps.row)"
						/>
					</template>

					<template v-if="slotProps.column.property === 'feeUnit'">
						<el-input v-model="slotProps.row.feeUnit" :readonly="pwaApcnPopUp.readOnlyAuth" maxlength="20" />
					</template>

					<template v-if="slotProps.column.property === 'totalPrice'">
						{{ slotProps.row.totalPrice }}
					</template>
				</template>
			</sf-data-table>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			localRows: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		cols() {
			return [
				{ prop: 'no', label: 'NO', width: '60px', custom: true },
				{ prop: 'feeTypeCd', label: '* ' + this.getMessage_('QWCC002140'), custom: true },
				{ prop: 'remark', label: '* ' + this.getMessage_('QWCC001527'), custom: true },
				{ prop: 'unitPrice', label: '* ' + this.getMessage_('QWCC002141'), width: '120px', custom: true },
				{ prop: 'feeQty', label: '* ' + this.getMessage_('QWCC001236'), width: '100px', custom: true },
				{ prop: 'feeUnit', label: '* ' + this.getMessage_('QWCC001124'), width: '100px', custom: true },
				{ prop: 'totalPrice', label: this.getMessage_('QWCC002142'), width: '120px', custom: true }
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		getFeeTypeLabel(val) {
			const opt = this.feeTypeOptions.find(o => o.commCd === val);
			return opt ? opt.commCdName : val;
		},
		parseDecimal2(val) {
			val = String(val).replace(/[^-\.0-9]/g, '');
			const arr = val.split('.');
			if (arr.length > 2) return val;
			if (arr.length === 2 && arr[1].length > 2) {
				arr[1] = arr[1].slice(0, 2);
				val = arr.join('.');
			}
			return val;
		},
		calcRowTotal(row) {
			const price = parseFloat(row.unitPrice) || 0;
			const qty = parseFloat(row.feeQty) || 0;
			return String(Math.round(price * qty * 100) / 100);
		},
		addRow() {
			this.localRows.push({
				no: this.localRows.length + 1,
				feeTypeCd: '',
				remark: '',
				unitPrice: '0',
				feeQty: '1',
				feeUnit: 'EA',
				totalPrice: '0'
			});
			this.syncAndCompute();
		},
		deleteRows() {
			const selected = this.$refs.otherFeeTable.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				});
				return;
			}
			this.localRows = this.localRows
				.filter(r => !selected.includes(r))
				.map((r, i) => ({ ...r, no: i + 1 }));
			this.syncAndCompute();
		},
		onUnitPriceInput(val, row) {
			row.unitPrice = this.parseDecimal2(val);
			row.totalPrice = this.calcRowTotal(row);
			this.syncAndCompute();
		},
		onQtyInput(val, row) {
			row.feeQty = this.parseDecimal2(val);
			row.totalPrice = this.calcRowTotal(row);
			this.syncAndCompute();
		},
		onCellChange() {
			this.syncAndCompute();
		},
		sumByTypes(types) {
			return this.localRows
				.filter(r => types.includes(r.feeTypeCd))
				.reduce((sum, r) => sum + (parseFloat(r.totalPrice) || 0), 0);
		},
		syncAndCompute() {
			// 同步到store供save使用
			this.setState_({ key: 'otherFeeList', value: this.localRows.slice() });
		},
		validate() {
			for (let i = 0; i < this.localRows.length; i++) {
				const row = this.localRows[i];
				const no = row.no;
				if (!row.feeTypeCd) {
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('MWCC000116'), [`NO.${no} ${this.getMessage_('QWCC002140')}`]) });
					return false;
				}
				if (!row.remark) {
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('MWCC000116'), [`NO.${no} ${this.getMessage_('QWCC001527')}`]) });
					return false;
				}
				if (!row.unitPrice) {
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('MWCC000116'), [`NO.${no} ${this.getMessage_('QWCC002141')}`]) });
					return false;
				}
				if (!row.feeQty) {
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('MWCC000116'), [`NO.${no} ${this.getMessage_('QWCC001236')}`]) });
					return false;
				}
				if (!row.feeUnit) {
					this.$sf_toast({ type: 'error', message: this.$sf_formatString(this.getMessage_('MWCC000116'), [`NO.${no} ${this.getMessage_('QWCC001124')}`]) });
					return false;
				}
			}
			return true;
		},
		setProcessInfo() {
			// 由父组件在重新加载数据后调用（如임시저장后）
			this.localRows = (this.otherFeeList || []).map((row, i) => ({ ...row, no: i + 1 }));
			this.syncAndCompute();
		}
	},
	async created() {
		await this.getCommCodes_({ key: 'feeTypeOptions', codeType: 'APCN_OTHER_FEE' });
		if (this.otherFeeList && this.otherFeeList.length > 0) {
			this.localRows = this.otherFeeList.map((row, i) => ({ ...row, no: i + 1 }));
			this.syncAndCompute();
		}else{
			this.localRows = [];
		}
	}
};
</script>
